import React from 'react';
import { twMerge } from 'tailwind-merge';
/**
 * CT Group signature swoosh / orbit device — echoes the brand's real
 * blue-curve motif (from ctgroup.com.au) to warm and identify dark sections.
 * Purely decorative.
 */
export function BrandCurve({
  className,
  color = 'rgba(0,168,232,0.16)',
  stroke = 'rgba(79,188,236,0.28)'
}: {
  className?: string;
  color?: string;
  stroke?: string;
}) {
  return <svg className={twMerge('pointer-events-none absolute', className)} viewBox="0 0 600 600" fill="none" aria-hidden data-id="element-496">
      <path d="M300 40c143 0 260 116 260 260 0 96-52 180-130 225 44-40 72-98 72-162 0-121-98-219-219-219-64 0-122 28-162 72C166 138 224 40 300 40z" fill={color} data-id="element-497" />
      <path d="M300 120c99 0 180 81 180 180 0 66-36 124-89 155 27-27 44-64 44-105 0-83-67-150-150-150-41 0-78 17-105 44 31-53 89-124 120-124z" fill={color} opacity="0.55" data-id="element-498" />
      <circle cx="300" cy="300" r="205" stroke={stroke} strokeWidth="1.5" fill="none" data-id="element-499" />
      <circle cx="300" cy="300" r="150" stroke={stroke} strokeWidth="1.5" fill="none" opacity="0.6" data-id="element-500" />
    </svg>;
}